var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 21 21",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.0675 8.0752v7.9248h-1.36229v-7.9248zm-1.46483-2.10206c0-.21972.06592-.40527.19776-.55664.13671-.15136.33687-.22705.60057-.22705.2588 0 .4566.07569.5933.22705.1416.15137.2124.33692.2124.55664 0 .20997-.0708.39063-.2124.542-.1367.14648-.3345.21972-.5933.21972-.2637 0-.46386-.07324-.60057-.21972-.13184-.15137-.19776-.33203-.19776-.542z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.213989125c541e49a40ffa3d8f791baa.svg";
export { ForwardRef as ReactComponent };